<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Stage bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditStageDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-1" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="EditStageForm" lazy-validation>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Naam"
          v-model.trim="selectedStage.name"
          background-color="background"
          prepend-icon="account_box"
          required
        ></v-text-field>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Omschrijving"
          v-model.trim="selectedStage.description"
          prepend-icon="info"
          hint="Vul een korte omschrijving in van deze Journey Stage"
          background-color="background"
          persistent-hint
          required
        ></v-text-field>
        <div class="select-color-field clear">
          <label>Kleur</label>
          <div class="color-field">
            <swatches
              v-model="selectedStage.color"
              :colors="colors"
              :exceptions="exceptions"
              :wrapper-style="wrapperStyle"
              :swatch-style="swatchStyle"
              exception-mode="hidden"
              swatch-size="36"
              show-border
              inline
            ></swatches>
          </div>
          <div class="custom-hint">
            De kleur wordt weergegeven in de grafiek met resultaten
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditStageDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateStage()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css";

export default {
  name: "edit-stage-form",
  props: {
    activeComp: Object,
    selectedStageOriginal: Object,
    selectedStage: Object,
    exceptions: Array,
  },
  components: { Swatches },

  data() {
    return {
      colors: [
        "#72D9C4",
        "#83C0EC",
        "#BC8DD0",
        "#F39488",
        "#F8DD65",
        "#E89861",
        "#61C1AD",
      ],
      wrapperStyle: { paddingTop: "0", paddingLeft: "0" },
      swatchStyle: { marginBottom: "0" },
      feedback: null,
    };
  },

  methods: {
    closeEditStageDialog() {
      this.$emit("editStageDialogChange", false);
    },

    updateStage() {
      if (
        this.selectedStage.name &&
        this.selectedStage.description &&
        this.selectedStage.color
      ) {
        db.collection("stages")
          .doc(this.selectedStage.id)
          .update({
            name: this.selectedStage.name,
            description: this.selectedStage.description,
            color: this.selectedStage.color,
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Journey Stage gewijzigd: " + this.activeComp.name,
                extra:
                  "<b>ORIGINELE GEGEVENS</b> " +
                  "<br>" +
                  "<b>Naam:</b> " +
                  this.selectedStageOriginal.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.selectedStageOriginal.description +
                  "<br>" +
                  "<b>Color:</b> " +
                  this.selectedStageOriginal.color +
                  "<br><br>" +
                  "<b>AAGENPASTE GEGEVENS</b> " +
                  "<br>" +
                  "<b>Naam:</b> " +
                  this.selectedStage.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.selectedStage.description +
                  "<br>" +
                  "<b>Color:</b> " +
                  this.selectedStage.color,
              })
              .catch((error) => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.$emit("reloadQuestions");
            this.$refs.EditStageForm.reset();
            this.closeEditStageDialog();
            console.log("Stage succesfully updated");
          })
          .catch((error) => {
            console.error("Error updating Stage: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating Stage: " + this.activeComp.name,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een stage te wijzigen.";
      }
    },
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    changed() {
      if (_.isEqual(this.selectedStage, this.selectedStageOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
